import React from 'react';
import { useTranslation } from 'react-i18next';

const SurveyPage = () => {
  const { t } = useTranslation();
  const languages = [
    'English',
    'Hindi',
    'Tamil',
    'Marathi',
    'Gujarati',
    'Telugu'
  ];

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-white to-blue-50">

      {/* Main Content Section */}
      <div className="container mx-auto px-4 py-12">
        {/* Header Section */}
        <div className="text-center mb-12 animate-fadeIn">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            {t('survey.title')}
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('survey.subtitle')}
          </p>
        </div>

        {/* Survey Information Section */}
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8 mb-8">
          <div className="prose max-w-none">
            <p className="text-gray-700 mb-6">
              {t('survey.surveyIntro')}
            </p>
            
            {/* Language Support */}
            <div className="bg-blue-50 rounded-lg p-6 mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">{t('survey.availableLanguages')}</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {languages.map((language, index) => (
                  <div key={index} className="flex items-center space-x-2 text-gray-700">
                    <i className="fas fa-check-circle text-green-500"></i>
                    <span>{language}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Survey Link */}
            <div className="text-center">
              <a href="https://bit.ly/3ZYPXAk" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-300">
                <i className="fas fa-external-link-alt mr-2"></i>
                {t('survey.takeSurvey')}
              </a>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">{t('survey.whyParticipate')}</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-chart-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">{t('survey.improveSafety')}</h3>
                  <p className="text-gray-600">{t('survey.improveSafetyDesc')}</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-robot text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">{t('survey.aiSolutions')}</h3>
                  <p className="text-gray-600">{t('survey.aiSolutionsDesc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SurveyPage;
